// 路径
var config = {
  // 正式
  apiUrl: "/api",
  url: ""
  // apiUrl: 'http:///127.0.0.1:11009',
  // apiUrl: 'http:/47.114.137.182:/',
};
if (process.env.NODE_ENV === "development") {
  config.apiUrl = "https://api5-dev.fjlanmax.com/partner"; // 开发
  config.login = "https://api5-dev.fjlanmax.com"; // 开发
  config.url = "https://mngr5-dev.fjlanmax.com";
} else if (process.env.NODE_ENV === "testing") {
  config.apiUrl = "https://api5-test.fjlanmax.com/partner"; // 测试
  config.login = "https://api5-test.fjlanmax.com"; // 开发
  config.url = "https://mngr5-test.fjlanmax.com";
} else if (process.env.NODE_ENV === "production") {
  config.apiUrl = "https://api5.fjlanmax.com/partner"; // 线上环境
  config.login = "https://api5.fjlanmax.com"; // 开发
  config.url = "https://mngr5.fjlanmax.com";
}

// 暴露出去
export default config;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 19